import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagAW = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#338AF3",
  d: "M25 50c7.577 0 14.367-3.371 18.951-8.696H6.05C10.633 46.63 17.423 50 25 50ZM50 25C50 11.193 38.807 0 25 0S0 11.193 0 25c0 2.256.3 4.442.861 6.522H49.14c.56-2.08.861-4.265.861-6.522ZM1.987 34.783a24.926 24.926 0 0 0 1.682 3.26h42.662c.636-1.039 1.2-2.128 1.682-3.26H1.987Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "m11.457 15.768-4.885-2.155 4.885-2.156 2.155-4.884 2.156 4.884 4.884 2.156-4.884 2.155-2.156 4.885-2.155-4.885Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "m13.612 9.264 1.332 3.016 3.016 1.332-3.017 1.331-1.33 3.016-1.332-3.016-3.017-1.331 3.017-1.332 1.331-3.016Z"
}));
FlagAW.displayName = 'FlagAW';
export default withFlagWrapper(FlagAW);
//# sourceMappingURL=index.js.map